import Cliente from "../Cliente";

export const getOpportunitiesAndContacts = (params = {}) => {
    return Cliente.setBearerToken()
        .getCliente()
        .get(`${process.env.REACT_APP_API_URL}opportunities/opportunities-contacts/`,{params: params});
};